import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGS, translations } from "./translations";

const I18nContext = createContext(null);
const STORAGE_KEY = "credom_lang";

const getInitial = () => {
  if (typeof window === "undefined") return "cs";
  // Query param wins (used by hreflang alternate URLs and shared links)
  try {
    const qs = new URLSearchParams(window.location.search);
    const q = qs.get("lang");
    if (q && translations[q]) return q;
  } catch {
    // ignore
  }
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
  } catch {
    // ignore
  }
  return "cs";
};

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitial);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      langs: LANGS,
      t: translations[lang] || translations.cs,
    }),
    [lang]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
};
